import { defineComponent as u, useAttrs as f, inject as h, ref as k, computed as g, createElementBlock as v, createCommentVNode as i, openBlock as n, createElementVNode as c, createBlock as m, resolveDynamicComponent as w, toRaw as p, mergeProps as o, unref as t, renderSlot as S } from "vue";
import { sizeInjectionKey as x } from "../HorizontalSeriesBlock/HorizontalSeriesBlock.constant.js";
import { RevIllustration as y } from "@ds/components/Illustration";
import { tw as r } from "../../utils/tailwind.js";
const z = {
  key: 0,
  class: "min-h-48 w-160 shrink-0 list-none md:max-w-none md:flex-1"
}, B = { class: "flex h-full items-center md:w-full" }, j = /* @__PURE__ */ u({
  name: "RevHorizontalSeriesBlockItem",
  inheritAttrs: !1,
  __name: "HorizontalSeriesBlockItem",
  props: {
    icon: {},
    imageSrc: {}
  },
  setup(e) {
    const l = f(), s = h(x, k("large")), a = g(() => [
      r`mr-12 shrink-0 align-middle`,
      s.value === "small" && r`p-12`,
      s.value === "large" && r`p-0`
    ]);
    return (d, C) => e.icon || e.imageSrc ? (n(), v("li", z, [
      c("div", B, [
        e.icon ? (n(), m(w(p(e.icon)), o({ key: 0 }, t(l), {
          class: a.value,
          "data-test": "icon",
          size: "48"
        }), null, 16, ["class"])) : e.imageSrc ? (n(), m(t(y), o({
          key: 1,
          alt: ""
        }, t(l), {
          class: a.value,
          height: 48,
          role: "presentation",
          src: e.imageSrc,
          width: 48
        }), null, 16, ["class", "src"])) : i("", !0),
        c("span", o(t(l), { class: "body-2 inline-block overflow-hidden break-words text-left align-middle md:flex-1" }), [
          S(d.$slots, "default")
        ], 16)
      ])
    ])) : i("", !0);
  }
});
export {
  j as default
};
